import { Box, Checkbox, IconButton } from '@mui/material'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import { useSelector } from 'react-redux'
import { TimesheetStoreState } from '../../../../../store/timesheetStore'
import { useIsTimesheetApproved } from '../../../../../utils/hooks'

interface ServiceActionsProps {
	hasNotes: boolean
	isReserveService: boolean
	isSecondaryDriverService: boolean
	isClean: boolean
	onCleanChange: (checked: boolean) => void
	onPrintService: (e: React.MouseEvent) => void
	instance: number
}

export default function ServiceActions({
	hasNotes,
	isReserveService,
	isSecondaryDriverService,
	isClean,
	onCleanChange,
	onPrintService,
	instance,
}: Readonly<ServiceActionsProps>) {
	const isTimeSheetApproved = useIsTimesheetApproved()
	const timesheetApprovalDetailsAccept = useSelector(
		(state: TimesheetStoreState) => state.timesheetApprovalDetailsAccept,
	)

	return (
		<>
			{/* Notas */}
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '69px',
					margin: 'auto 0',
					padding: '0.75rem 1rem',
				}}
			>
				<Checkbox
					aria-label='Service Has Notes'
					checked={hasNotes}
					disabled
					sx={{ color: 'var(--primary-light)', '&.Mui-checked': { color: 'var(--primary)' } }}
				/>
			</Box>

			{/* Limpeza */}
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '84px',
					margin: 'auto 0',
					padding: '0.75rem 1rem',
				}}
			>
				{isReserveService ? (
					'-'
				) : (
					<Checkbox
						aria-label='Service Vehicle Hygiene Status'
						checked={
							isTimeSheetApproved ? timesheetApprovalDetailsAccept.services[instance]?.isClean ?? false : isClean
						}
						disabled={isSecondaryDriverService}
						onClick={e => e.stopPropagation()}
						onChange={e => onCleanChange(e.target.checked)}
						sx={{ color: 'var(--primary-light)', '&.Mui-checked': { color: 'var(--primary)' } }}
					/>
				)}
			</Box>

			{/* Imp / Exp */}
			<Box sx={{ width: '100%', padding: '0.75rem 1rem', margin: 'auto 0' }}>
				<IconButton
					aria-label='export service'
					size='small'
					sx={{ width: '20px', height: '20px' }}
					onClick={onPrintService}
				>
					<SaveAltIcon sx={{ color: 'var(--primary)' }} />
				</IconButton>
			</Box>
		</>
	)
}
